export const getSignatureStatusLabel = (status?: string | null, fallback: string | null = null) => {
  switch (status?.trim().toUpperCase()) {
    case 'SENT':
      return 'Sent'
    case 'VIEWED':
      return 'Viewed'
    case 'FINISH_LATER':
      return 'Not completed'
    case 'SIGNED':
    case 'COMPLETED':
      return 'Signed'
    case 'DECLINED':
      return 'Declined'
    case 'VOIDED':
      return 'Voided'
    case 'EXPIRED':
      return 'Expired'
    default:
      return status?.trim() || fallback
  }
}
